import { APP_CONTEXTS, IAppInitParams } from "app/model"
import { Action } from "redux"

export enum ACTIONS {
  APP_IS_LOADING_DATA = "APP_IS_LOADING_DATA",
  RESET = "RESET",
  USER_LOGIN = "USER_LOGIN",
  USER_LOGOUT = "USER_LOGOUT",
  USER_RENEW_SESSION = "USER_RENEW_SESSION",
  USER_START_LOGGING_IN = "USER_START_LOGGING_IN",
  USER_STOP_LOGGING_IN = "USER_STOP_LOGGING_IN",
  USER_OPEN_RE_LOGIN_POPUP = "USER_OPEN_RE_LOGIN_POPUP",
  USER_SIGN_UP_WIZARD_CLEAR = "USER_SIGN_UP_WIZARD_CLEAR",
  USER_SIGN_UP_WIZARD_CLEAR_STATUS = "USER_SIGN_UP_WIZARD_CLEAR_STATUS",
  USER_SIGN_UP_SET_STATUS = "USER_SIGN_UP_SET_STATUS",
  USER_SIGN_UP_WIZARD_SET_STEP = "USER_SIGN_UP_WIZARD_SET_STEP",
  USER_SIGN_UP_WIZARD_SET_USER_FORM = "USER_SIGN_UP_WIZARD_SET_USER_FORM",
  USER_SIGN_UP_WIZARD_SET_AGENCY_FORM = "USER_SIGN_UP_WIZARD_SET_AGENCY_FORM",
  APP_INIT_DATA = "APP_INIT_DATA",
  APP_STOP_INIT_DATA = "APP_STOP_INIT_DATA",
  APP_INIT_DATA_START = "APP_INIT_DATA_START",
  APP_INIT_DATA_ERROR = "APP_INIT_DATA_ERROR",
  APP_SET_ACTIVE_CONTEXT = "APP_SET_ACTIVE_CONTEXT",
  APP_UI_RESET_STATE = "APP_UI_RESET_STATE",
  APP_UI_SET_THEME = "APP_UI_SET_THEME",
  APP_UI_SET_CONTAINER_SIZE = "APP_UI_SET_CONTAINER_SIZE",
  APP_UI_SET_MENU_SIZE = "APP_UI_SET_MENU_SIZE",
  APP_UI_SET_IS_SAVING_CONFIG = "APP_UI_SET_IS_SAVING_CONFIG",
  APP_UI_SET_TEMP_UI_CONFIG = "APP_UI_SET_TEMP_UI_CONFIG",
  APP_UI_SET_UI_CONFIG_TRANSLATIONS = "APP_UI_SET_UI_CONFIG_TRANSLATIONS",
  APP_UI_SET_IS_DARK_PREVIEW = "APP_UI_SET_IS_DARK_PREVIEW",
  APP_UI_SET_UNDO_REDO_UI_CONFIG_STATE = "APP_UI_SET_UNDO_REDO_UI_CONFIG_STATE",
  APP_UI_SET_MENUS = "APP_UI_SET_MENUS",
  APP_UI_OPEN_COLOR_PICKER_POPUP = "APP_UI_OPEN_COLOR_PICKER_POPUP",
  APP_UI_CLOSE_COLOR_PICKER_POPUP = "APP_UI_CLOSE_COLOR_PICKER_POPUP",
  APP_MESSAGE_ADD_OVERLAY_MESSAGE = "APP_MESSAGE_ADD_OVERLAY_MESSAGE",
  APP_MESSAGE_DELETE = "APP_MESSAGE_DELETE",
  APP_MESSAGE_DELETE_OVERLAY_MESSAGES = "APP_MESSAGE_DELETE_OVERLAY_MESSAGES",
  APP_MESSAGE_SET_CONFIRM_MESSAGE = "APP_MESSAGE_SET_CONFIRM_MESSAGE",
  APP_MESSAGE_ADD_MESSAGE = "APP_MESSAGE_ADD_MESSAGE",
  ORDER_ADD = "ORDER_ADD",
  ORDER_UPDATE = "ORDER_UPDATE",
  LANGUAGE_SET_LOCALE = "LANGUAGE_SET_LOCALE",
  PAGE_SET_ALL = "PAGE_SET_ALL",
  PAGE_ACTIVATE = "PAGE_ACTIVATE",
  AGENCY_INIT = "AGENCY_INIT",
  AGENCY_START_INIT = "AGENCY_START_INIT",
  AGENCY_INIT_ERROR = "AGENCY_INIT_ERROR",
  ADVERTISER_INIT = "ADVERTISER_INIT",
  ADVERTISER_START_INIT = "ADVERTISER_START_INIT",
  ADVERTISER_INIT_ERROR = "ADVERTISER_INIT_ERROR",
  ADVERTISER_ADD = "ADVERTISER_ADD",
  ADVERTISER_UPDATE = "ADVERTISER_UPDATE",
  ADVERTISER_SET_LIST = "ADVERTISER_SET_LIST",
  AGENCY_SET_STRIPE_USER_ID = "AGENCY_SET_STRIPE_USER_ID",
  SETTINGS_SET_PAGE = "SETTINGS_SET_PAGE",
  NOTIFICATION_ADD = "NOTIFICATION_ADD",
  NOTIFICATION_VISIBILITY = "NOTIFICATION_VISIBILITY",
  NOTIFICATION_SETTINGS_CHANGE = "NOTIFICATION_SETTINGS_CHANGE",
  NOTIFICATION_SETTINGS_UPDATED = "NOTIFICATION_SETTINGS_UPDATED",
  NOTIFICATION_SETTINGS_IS_LOADING = "NOTIFICATION_SETTINGS_IS_LOADING",
  NOTIFICATION_SETTINGS_HAS_LOADING_ERROR = "NOTIFICATION_SETTINGS_HAS_LOADING_ERROR",
  NOTIFICATION_SETTINGS_IS_UPDATING = "NOTIFICATION_SETTINGS_IS_UPDATING",
  NOTIFICATION_IS_LOADING = "NOTIFICATION_IS_LOADING",
  NOTIFICATION_HAS_LOADING_ERROR = "NOTIFICATION_HAS_LOADING_ERROR",
  NOTIFICATION_MARK_AS_READ = "NOTIFICATION_MARK_AS_READ",
  ADMIN_SET_ACTIVE_TAB = "ADMIN_SET_ACTIVE_TAB",
  ORDER_SET_LIST = "ORDER_SET_LIST",
  ORDER_OPEN_FORM_POPUP = "ORDER_OPEN_FORM_POPUP",
  ORDER_CLOSE_FORM_POPUP = "ORDER_CLOSE_FORM_POPUP",
  ORDER_SET_FORM = "ORDER_SET_FORM",
  CAMPAIGN_SET_LIST = "CAMPAIGN_SET_LIST",
  CAMPAIGN_SET_LIST_REPORTS = "CAMPAIGN_SET_LIST_REPORTS",
  CAMPAIGN_SET_LIST_ESTIMATES = "CAMPAIGN_SET_LIST_ESTIMATES",
  CAMPAIGN_SET_LIST_DSP_DEALS = "CAMPAIGN_SET_LIST_DSP_DEALS",
  CAMPAIGN_DUPLICATE_POPUP = "CAMPAIGN_DUPLICATE_POPUP",
  CAMPAIGN_UPDATE = "CAMPAIGN_UPDATE",
  CAMPAIGN_START_REFRESHING = "CAMPAIGN_START_REFRESHING",
  CAMPAIGN_STOP_REFRESHING = "CAMPAIGN_STOP_REFRESHING",
  CAMPAIGN_HAS_REFRESH_ERROR = "CAMPAIGN_HAS_REFRESH_ERROR",
  FORECAST_SET_FILTERS = "FORECAST_SET_FILTERS",
  TAG_ADD_USER_TAG = "TAG_ADD_USER_TAG",
  TAG_DELETE_USER_TAG = "TAG_DELETE_USER_TAG",
  FORM_SET = "FORM_SET",
  FORM_SET_IS_SAVING_CAMPAIGN = "FORM_SET_IS_SAVING_CAMPAIGN",
  FORM_START_SAVING_TEMP_CAMPAIGN = "FORM_START_SAVING_TEMP_CAMPAIGN",
  FORM_STOP_SAVING_TEMP_CAMPAIGN = "FORM_STOP_SAVING_TEMP_CAMPAIGN",
  FORM_SAVE_ERROR = "FORM_SAVE_ERROR",
  FORM_START_REFRESHING_INVENTORY = "FORM_START_REFRESHING_INVENTORY",
  FORM_HAS_REFRESH_INVENTORY_ERROR = "FORM_HAS_REFRESH_INVENTORY_ERROR",
  FORM_REFRESH_INVENTORY = "FORM_REFRESH_INVENTORY",
  FORM_SET_MAP_IS_REFRESHING = "FORM_SET_MAP_IS_REFRESHING",
  FORM_SET_RELATIONS = "FORM_SET_RELATIONS",
  FORM_SET_GEO_TARGETS = "FORM_SET_GEO_TARGETS",
  FORM_SET_GEO_TARGETS_FORM = "FORM_SET_GEO_TARGETS_FORM",
  FORM_SET_NO_INTERSECTION_ERROR = "FORM_SET_NO_INTERSECTION_ERROR",
  FORM_SET_GEO_TARGETS_SELECTION = "FORM_SET_GEO_TARGETS_SELECTION",
  FORM_START_LOADING = "FORM_START_LOADING",
  FORM_SET_ERROR = "FORM_SET_ERROR",
  FORM_SUMMARY_SET = "FORM_SUMMARY_SET",
  FORM_SUMMARY_CLOSE = "FORM_SUMMARY_CLOSE",
  FORM_SET_MAP_VISIBILITY = "FORM_SET_MAP_VISIBILITY",
  FORM_SET_MAP_IS_LOADING = "FORM_SET_MAP_IS_LOADING",
  FORM_SET_MAP_IS_LOADED = "FORM_SET_MAP_IS_LOADED",
  FORM_SET_MAP_LEGEND_DATA = "FORM_SET_MAP_LEGEND_DATA",
  FORM_SET_AUCTIONS = "FORM_SET_AUCTIONS",
  FORM_SET_ALL_OPERATORS = "FORM_SET_ALL_OPERATORS",
  FORM_SET_IS_LOADING_ALL_OPERATORS = "FORM_SET_IS_LOADING_ALL_OPERATORS",
  FORM_SET_HAS_LOADING_ALL_OPERATORS_ERROR = "FORM_SET_HAS_LOADING_ALL_OPERATORS_ERROR",
  FORM_SET_OPERATORS = "FORM_SET_OPERATORS",
  FORM_SET_ALL_SSP_DEALS = "FORM_SET_ALL_SSP_DEALS",
  FORM_SET_IS_LOADING_ALL_SSP_DEALS = "FORM_SET_IS_LOADING_ALL_SSP_DEALS",
  FORM_SET_HAS_LOADING_ALL_SSP_DEALS_ERROR = "FORM_SET_HAS_LOADING_ALL_SSP_DEALS_ERROR",
  FORM_SET_CAMPAIGN_SSP_DEALS = "FORM_SET_CAMPAIGN_SSP_DEALS",
  FORM_START_SYNCH_SSP_DEALS = "FORM_START_SYNCH_SSP_DEALS",
  FORM_STOP_SYNCH_SSP_DEALS = "FORM_STOP_SYNCH_SSP_DEALS",
  FORM_START_SYNCH_OPERATORS = "FORM_START_SYNCH_OPERATORS",
  FORM_STOP_SYNCH_OPERATORS = "FORM_STOP_SYNCH_OPERATORS",
  FORM_START_SYNCH_FORMATS = "FORM_START_SYNCH_FORMATS",
  FORM_STOP_SYNCH_FORMATS = "FORM_STOP_SYNCH_FORMATS",
  FORM_START_LOAD_OPERATORS_FORECAST = "FORM_START_LOAD_OPERATORS_FORECAST",
  FORM_STOP_LOAD_OPERATORS_FORECAST = "FORM_STOP_LOAD_OPERATORS_FORECAST",
  FORM_SET_OPERATORS_FORECAST = "FORM_SET_OPERATORS_FORECAST",
  FORM_SET_OPERATOR_FILTER = "FORM_SET_OPERATOR_FILTER",
  FORM_SET_SSPS = "FORM_SET_SSPS",
  FORM_START_SYNCH_SSPS = "FORM_START_SYNCH_SSPS",
  FORM_STOP_SYNCH_SSPS = "FORM_STOP_SYNCH_SSPS",
  FORM_SET_ENVIRONMENTS = "FORM_SET_ENVIRONMENTS",
  FORM_START_SYNCH_ENVIRONMENTS = "FORM_START_SYNCH_ENVIRONMENTS",
  FORM_START_LOAD_ENVIRONMENTS_FORECAST = "FORM_START_LOAD_ENVIRONMENTS_FORECAST",
  FORM_STOP_LOAD_ENVIRONMENTS_FORECAST = "FORM_STOP_LOAD_ENVIRONMENTS_FORECAST",
  FORM_SET_ENVIRONMENTS_FORECAST = "FORM_SET_ENVIRONMENTS_FORECAST",
  FORM_SET_ENVIRONMENTS_IS_TREE_VIEW = "FORM_SET_ENVIRONMENTS_IS_TREE_VIEW",
  FORM_STOP_SYNCH_ENVIRONMENTS = "FORM_STOP_SYNCH_ENVIRONMENTS",
  FORM_SET_ENVIRONMENTS_FILTER = "FORM_SET_ENVIRONMENTS_FILTER",
  FORM_SET_ENVIRONMENTS_EXPANDED_IDS = "FORM_SET_ENVIRONMENTS_EXPANDED_IDS",
  FORM_SET_AUDIENCE = "FORM_SET_AUDIENCE",
  FORM_START_SYNCH_AUDIENCE = "FORM_START_SYNCH_AUDIENCE",
  FORM_STOP_SYNCH_AUDIENCE = "FORM_STOP_SYNCH_AUDIENCE",
  FORM_SET_AUDIENCE_FILTER = "FORM_SET_AUDIENCE_FILTER",
  FORM_SET_ACTIVE_TAB = "FORM_SET_ACTIVE_TAB",
  FORM_SET_ACTIVE_SUMMARY_TAB = "FORM_SET_ACTIVE_SUMMARY_TAB",
  FORM_CLEAR_APP_FORM = "FORM_CLEAR_APP_FORM",
  FORM_REFRESH_FORMIK_FORM = "FORM_REFRESH_FORMIK_FORM",
  FORM_SET_GEO_TARGETS_FILE_IMPORT = "FORM_SET_GEO_TARGETS_FILE_IMPORT",
  FORM_SET_CREATIVE_FILTER = "FORM_SET_CREATIVE_FILTER",
  FORM_SET_CREATIVES = "FORM_SET_CREATIVES",
  FORM_START_LOAD_MEDIA_CREATIVE_FORECAST = "FORM_START_LOAD_MEDIA_CREATIVE_FORECAST",
  FORM_STOP_LOAD_MEDIA_CREATIVE_FORECAST = "FORM_STOP_LOAD_MEDIA_CREATIVE_FORECAST",
  FORM_SET_MEDIA_CREATIVE_FORECAST = "FORM_SET_MEDIA_CREATIVE_FORECAST",
  FORM_START_SYNCH_MEDIA_CREATIVE_FORECAST = "FORM_START_SYNCH_MEDIA_CREATIVE_FORECAST",
  FORM_STOP_SYNCH_MEDIA_CREATIVE_FORECAST = "FORM_STOP_SYNCH_MEDIA_CREATIVE_FORECAST",
  FORM_SET_HAS_SYNCH_MEDIA_CREATIVE_FORECAST_ERROR = "FORM_SET_HAS_SYNCH_MEDIA_CREATIVE_FORECAST_ERROR",
  FORM_SET_DSP_DEALS_FORMATS = "FORM_SET_DSP_DEALS_FORMATS",
  REPORTS_SET_EDIT_FORM = "REPORTS_SET_EDIT_FORM",
  REPORTS_SET_FORM_IS_UPDATING = "REPORTS_SET_FORM_IS_UPDATING",
  REPORTS_SET_PARAMETERS = "REPORTS_SET_PARAMETERS",
  REPORTS_SET_RESULTS = "REPORTS_SET_RESULTS",
  REPORTS_SET_IS_PARAMETERS_PANEL_OPENED = "REPORTS_SET_IS_PARAMETERS_PANEL_OPENED",
  REPORTS_SET_RESULT_IS_LOADING = "REPORTS_SET_RESULT_IS_LOADING",
  REPORTS_SET_RESULT_HAS_LOADING_ERROR = "REPORTS_SET_RESULT_HAS_LOADING_ERROR",
  REPORTS_SET_LIST_IS_LOADING = "REPORTS_SET_LIST_IS_LOADING",
  REPORTS_SET_LIST_HAS_LOADING_ERROR = "REPORTS_SET_LIST_HAS_LOADING_ERROR",
  REPORTS_ADD = "REPORTS_ADD",
  REPORTS_UPDATE = "REPORTS_UPDATE",
  REPORTS_DELETE = "REPORTS_DELETE",
  REPORTS_SET_LIST = "REPORTS_SET_LIST",
  REVENUE_START_LOADING = "REVENUE_START_LOADING",
  REVENUE_SET = "REVENUE_SET",
  REVENUE_SET_ERROR = "REVENUE_SET_ERROR",
  MEDIA_APPROVAL_START_LOADING = "MEDIA_APPROVAL_START_LOADING",
  MEDIA_APPROVAL_HAS_ERROR = "MEDIA_APPROVAL_HAS_ERROR",
  MEDIA_APPROVAL_SET_LIST = "MEDIA_APPROVAL_SET_LIST",
  MEDIA_APPROVAL_SET_FILTER_IS_EXPANDED = "MEDIA_APPROVAL_SET_FILTER_IS_EXPANDED",
  MEDIA_APPROVAL_SET_FILTERS = "MEDIA_APPROVAL_SET_FILTERS",
  MEDIA_APPROVAL_UPDATE = "MEDIA_APPROVAL_UPDATE",
  MEDIA_APPROVAL_START_UPDATING = "MEDIA_APPROVAL_START_UPDATING",
  MEDIA_APPROVAL_STOP_UPDATING = "MEDIA_APPROVAL_STOP_UPDATING"
}

export interface IAppActionInitData extends Action, IAppInitParams {
  // nothing to add
}

export interface IAppActionSetContext extends Action {
  context: APP_CONTEXTS | null
}

export const appActionCreator = {
  initData(data: IAppInitParams): IAppActionInitData {
    return {
      type: ACTIONS.APP_INIT_DATA,
      ...data
    }
  },
  startInitData(): Action {
    return {
      type: ACTIONS.APP_INIT_DATA_START
    }
  },
  stopInitData(): Action {
    return {
      type: ACTIONS.APP_STOP_INIT_DATA
    }
  },
  initDataError(): Action {
    return {
      type: ACTIONS.APP_INIT_DATA_ERROR
    }
  },
  setAppContext(context: APP_CONTEXTS | null): IAppActionSetContext {
    return {
      type: ACTIONS.APP_SET_ACTIVE_CONTEXT,
      context
    }
  }
}
